import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    materialList: () => {
        return HTTP.get('/stock/material_all', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addMaterial: (data) => {
        return HTTP.post('/stock/material_create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editMaterial: (id,data) => {
        return HTTP.post(`/stock/material_update/${id}`,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailMaterial: (id) => {
        return HTTP.post(`/stock/material_edit/${id}`, null,{
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    deleteMaterial: (id) => {
        return HTTP.post(`/stock/material_delete/${id}`, null,{
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}